import { useEffect } from "react";

type Params = { enabled: boolean };

export const useDynamicDeviceScaling = ({ enabled }: Params) => {
  useEffect(() => {
    const body = document.body;

    const reset = () => {
      body.style.position = "";
      body.style.width = "";
      body.style.height = "";
      body.style.transform = "";
      body.style.transformOrigin = "";
      body.style.left = "";
      body.style.top = "";
      body.style.maxHeight = "";
      body.style.minHeight = "";
    };

    if (!enabled) {
      reset();
      return;
    }

    const apply = () => {
      const { innerWidth, innerHeight } = window;

      const aspectRatio = innerHeight / innerWidth;
      const baseWidth = 375;
      const baseHeight = Math.floor(baseWidth * aspectRatio);
      const scale = innerWidth / baseWidth;

      const offsetLeft = (innerWidth - baseWidth * scale) / 2;
      const offsetTop = (innerHeight - baseHeight * scale) / 2;

      body.style.position = "absolute";
      body.style.width = `${baseWidth}px`;
      body.style.height = `100%`;
      body.style.transform = `scale(${scale})`;
      body.style.transformOrigin = "top left";
      body.style.left = `${offsetLeft}px`;
      body.style.top = `${offsetTop}px`;
      body.style.maxHeight = `${baseHeight}px`;
      body.style.minHeight = `${baseHeight}px`;
    };

    apply();
    window.addEventListener("resize", apply);

    return () => {
      window.removeEventListener("resize", apply);
      reset();
    };
  }, [enabled]);
};
